<template>
    <div class="body-padding login-box">
        <div class="login">
            <div data-placeholder="请输入手机号" class="phone-line">
                <input class="phone" type="tel" v-model="mobile" maxlength="13" placeholder="请输入手机号">
                <div class="send-line" v-show="isCaptcha">
                    <button v-show="count === 0" class="send-code-text" :disabled="sendDisabled"
                            @click="handleSendCaptcha">发送验证码
                    </button>
                    <button v-show="count !== 0" class="send-code-text" :disabled="sendDisabled"
                            @click="handleSendCaptcha">重新发送({{count}})
                    </button>
                </div>
            </div>

            <!--验证码-->
            <div class="captcha-wrap" v-show="isCaptcha">
                <div data-passwordPlaceholder="请输入验证码" class="captcha-line">
                    <div class="is-send"><span
                            v-show="count !== 0">已向您的手机 {{mobile.substring(mobile.length - 4)}} 发送验证码</span></div>
                    <input ref="captcha" type="tel" v-model="captcha" maxlength="4" class="invisible-password"/>
                    <p class="letters" @click="handleInputFocus">
                        <span class="placeholder-text">{{captcha.length > 0 ? '' : captchaText}}</span>
                        <span class="num">{{captcha[0]}}</span>
                        <span class="num">{{captcha[1]}}</span>
                        <span class="num">{{captcha[2]}}</span>
                        <span class="num">{{captcha[3]}}</span>
                    </p>
                </div>
                <div class="btn-wrap">
                    <van-button class="login-btn" :disabled="loginDisabled" size="small" type="warning" round
                                @click="doLogin">登&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录
                    </van-button>
                    <!--<van-button to="/user/register" class="register-btn" size="small" type="warning" round>注&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;册</van-button>-->
                </div>
                <div class="toggle-btn" @click="handleToggle">账号密码登录</div>
            </div>


            <!--密码-->
            <div class="password-wrap" v-show="!isCaptcha">
                <div data-placeholder="请输入密码" class="password-line">
                    <input type="password" v-model="password" placeholder="请输入密码(6~20位英文或数字)" class="password"/>
                </div>
                <div class="btn-wrap">
                    <van-button :disabled="loginDisabled" class="login-btn" size="small" type="warning" round
                                @click="doLogin">登&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录
                    </van-button>
                </div>
                <div class="toggle-btn" @click="handleToggle">验证码登录</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Cookie from "js-cookie";

    export default {
        name: "PcLogin",
        data() {
            return {
                captchaText: '请输入发送至手机的验证码',
                captcha: '',
                mobile: '',
                password: '',
                userId: '',
                isCaptcha: true,
                isSend: false,
                count: 0
            }
        },
        watch: {
            mobile(val, oldVal) {
                if (val && isNaN(parseInt(val[val.length - 1]))) {
                    console.log(parseInt(val.substring(0, val.length - 1)))
                    this.mobile = oldVal
                }

                if (oldVal.length >= 12) {
                    this.mobile = val.replace(/\s+/g, '')
                } else if (val.length === 11) {
                    let arr = val.split('')
                    arr.splice(7, 0, ' ')
                    arr.splice(3, 0, ' ')
                    this.mobile = arr.join('')
                }
            },
        },
        computed: {
            loginDisabled() {
                if (this.mobile.length !== 13) return true
                if (this.isCaptcha) {
                    return !(this.captcha.length === 4)
                } else {
                    return !(this.password.length >= 6 && this.password.length <= 20)
                }
            },
            sendDisabled() {
                return this.mobile.length !== 13 || (this.count !== 0)
            }
        },
        methods: {
            handleToggle() {
                this.isCaptcha = !this.isCaptcha
            },
            handleInputFocus() {
                this.$refs.captcha.focus()
            },
            handleSendCaptcha() {
                let params = {
                    mobile: this.mobile.replace(/\s/g, '')
                }
                this.$toast.loading({
                    duration: 0,
                    mask: true,
                    message: '短信发送中...'
                })
                this.$axios({
                    url: 'user/captcha',
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    },
                    params
                }).then(() => {
                    let TIME_COUNT = 60
                    let count = TIME_COUNT
                    this.count = 60
                    this.timer = setInterval(() => {
                        if (count > 1 && count <= TIME_COUNT) {
                            count--
                            this.count = count
                        } else {
                            clearInterval(this.timer)
                            this.timer = null
                            this.isSend = false
                            this.count = 0
                        }
                    }, 1000);
                    this.$toast.clear()
                }).catch(err => {
                    this.$toast({
                        message: err.data.msg,
                        duration: 1000
                    })
                })
            },
            async doLogin() {
                this.$toast.loading({
                    duration: 0,
                    forbidClick: true,
                    message: '登录中...',
                    mask: true
                })
                let mobile = this.mobile.replace(/\s/g, '')
                let params = {
                    params: {
                        loginType: 5,
                        mobile: mobile,
                        code: this.captcha
                    }
                }
                this.$axios.post('user/checkRegister', params).then(() => { // 未注册
                    this.$toast.clear()
                    return this.$dialog.confirm({
                        message: '手机号' + mobile + '尚未注册，是否立即注册',
                        confirmButtonText: '注册并登录',
                        closeOnClickOverlay: true
                    })
                }).then(() => { // 未注册且确认立即注册
                    if (this.isCaptcha) this.handleCaptchaLogin()
                    else this.$router.push({
                        name: 'Register'
                    })
                }).catch(err => {
                    this.$toast.clear()
                    if (err === 'cancel') return
                    if (err.data.code === 100020002) { // 已注册
                        if (this.isCaptcha) this.handleCaptchaLogin()
                        else this.handlePasswordLogin()
                        return
                    }
                    this.$toast({
                        message: err.data.msg,
                        duration: 1000
                    })
                })
            },
            handleCaptchaLogin() {
                let mobile = this.mobile.replace(/\s/g, '')
                let params = {
                    params: {
                        loginType: 5,
                        mobile: mobile,
                        code: this.captcha,
                        logisticsCompanyId: this.$logisticsCompanyId
                    }
                }
                this.$axios.post('auth/code', params).then(res => {
                    this.loginSuccess(res)
                }).catch(err => {
                    this.$toast({
                        message: err.data.msg,
                        duration: 1000
                    })
                })
            },
            handlePasswordLogin() {
                let mobile = this.mobile.replace(/\s/g, '')
                let params = {
                    params: {
                        loginType: 5,
                        mobile: mobile,
                        password: this.password
                    }
                }
                this.$axios.post('auth/token', params).then(res => {
                    this.loginSuccess(res)
                }).catch(err => {
                    if (err.data.msg) {
                        this.$toast({
                            message: err.data.msg,
                            duration: 1000
                        })
                    }
                })
            },
            loginSuccess(res) {
                let mobile = this.mobile.replace(/\s/g, '')
                let data = res.data.data
                this.userId = data.accid
                let token = {
                    token: data.token_type + ' ' + data.access_token
                }
                Cookie.set('yhb_token', JSON.stringify(token))
                localStorage.setItem('yhb_token', JSON.stringify(token))
                localStorage.setItem('yhb_phone', mobile)
                localStorage.setItem('yhb_userId', this.userId)
                localStorage.setItem('yhb_rememberPhone', mobile)
                this.$store.commit("getToken")
                this.wxLogin()
            },
            async wxLogin() {
                try {
                    let isWxLogin = window.navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
                    if (!isWxLogin) {
                        this.$router.push(this.$route.query.redirect || "/user")
                        this.$toast.clear()
                        return
                    }
                    let params = {
                        params: {
                            userId: this.userId,
                            loginType: 5,
                            wechatMark: this.$wechatMark
                        }
                    }
                    let openid = await this.$axios.post('weixin/get/openid', params)
                    if (openid.data.data) {
                        this.$router.push('/preorder')
                        return
                    }
                    params = {
                        params: {
                            wechatMark: this.$wechatMark,
                            callback: this.$callbackPage
                        }
                    }
                    this.$axios.get('weixin/getCodeUrl', params).then(res => {
                        window.location.href = res.data.data
                    })
                    this.$toast.clear()
                } catch (err) {
                    this.$toast({
                        message: err.data.msg,
                        duration: 1000
                    })
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .login-box {
        .login {
            background-color: #fff;
            height: 100%;
            font-size: 0.53rem;
            border-top: 1px solid transparent;

            .phone-line, .password-line {
                padding-top: 1.5rem;
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;

                .password, .phone {
                    line-height: 0.4rem;
                    margin-top: 0.4rem;
                    font-size: 0.4rem;
                    padding: 0.48rem 0.31rem;
                    flex-basis: 0;
                    border-bottom: 1px solid #BFBFBF;

                    &::-webkit-input-placeholder {
                        color: #747474;
                        font-size: 0.35rem;
                    }
                }

                &::after {
                    content: attr(data-placeholder);
                    position: absolute;
                    top: 0.6rem;
                    left: 0;
                    font-size: 0.53rem;
                    padding-left: 0.31rem;
                    font-weight: bold;
                    color: #4F4F4F;
                }
            }

            .captcha-line {
                padding-top: 1.5rem;
                position: relative;

                &::after {
                    content: attr(data-passwordPlaceholder);
                    position: absolute;
                    top: 0.6rem;
                    left: 0;
                    font-size: 0.53rem;
                    padding-left: 0.31rem;
                    font-weight: bold;
                    color: #4F4F4F;
                }

                .is-send {
                    font-size: 0.29rem;
                    line-height: 0.4rem;
                    height: 0.4rem;
                    color: #8F8F8F;
                    padding-left: 0.31rem;
                }

                .invisible-password {
                    padding-left: 0.1rem;
                    border: 0;
                    bottom: 0;
                    position: absolute;
                    height: 1.41rem;
                    font-size: 0.22rem;
                    text-indent: -999rem;
                    margin-left: -100%;
                }

                .letters {
                    height: 1.41rem;
                    font-size: 0.61rem;
                    display: flex;
                    position: relative;
                    align-items: center;
                    padding-left: 0.31rem;
                    padding-right: 0.31rem;

                    .placeholder-text {
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        font-size: 0.35rem;
                        color: #747474;
                        height: 1.41rem;
                        line-height: 1.41rem;
                        padding-left: 0.31rem;
                    }

                    .num {
                        flex: 1;
                        height: 1.41rem;
                        line-height: 1.41rem;
                        text-align: center;
                        border-bottom: 2px solid #BFBFBF;

                        & ~ .num {
                            margin-left: 1.03rem;
                        }
                    }
                }
            }

            .send-code-text {
                padding: 0;
                margin: 0;
                outline: 0;
                font-size: 0.29rem;
                letter-spacing: 0.05rem;
                color: #FE9329;
                border: 0;
                background-color: transparent;

                &[disabled] {
                    color: #8F8F8F;
                }
            }

            .send-line {
                text-align: center;
                height: 1.79rem;
                line-height: 1.79rem;
                position: absolute;
                right: 0.5rem;
                top: 1.6rem;
            }

            .login-btn__disabled {
                background-color: #BFBFBF;
                border: 1px solid #BFBFBF;
            }

        }
    }

    .password-wrap {

        .btn-wrap {
            margin-top: 2.36rem;
        }
    }

    .btn-wrap {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 1.6rem;

        .login-btn {
            width: 8.83rem;
            height: 0.96rem;
            line-height: 0.96rem;
            text-align: center;
            font-size: 0.4rem;
            margin-bottom: 0.24rem;

            &[disabled] {
                color: #ffffff;
                background: #BFBFBF;
            }
        }

        .register-btn {
            width: 8.83rem;
            height: 0.96rem;
            line-height: 0.96rem;
            text-align: center;
            font-size: 0.4rem;
            background-color: unset;
            color: #FE9329;
        }
    }

    .toggle-btn {
        color: #FE9329;
        font-size: 0.27rem;
        display: inline-block;
        padding: 0.23rem 0.31rem;
    }
</style>
